import SuperAutoComplete from './superAutoComplete';
import type { SuperAutoCompleteProps } from './interface';

export type { SuperAutoCompleteProps };

export default SuperAutoComplete;
